import FastCashAdminPanel from './FastCashAdminPanel';

export default FastCashAdminPanel;
